import { render, staticRenderFns } from "./contact-dialog.vue?vue&type=template&id=12d9e092&scoped=true&"
import script from "./contact-dialog.vue?vue&type=script&lang=js&"
export * from "./contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./contact-dialog.vue?vue&type=style&index=0&id=12d9e092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9e092",
  null
  
)

export default component.exports